import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CcListApiService } from '../../cc-list-api.service';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { IHeaderParams } from 'ag-grid-community';
import { IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-cc-row-menu-header',
  standalone: true,
  imports: [
    GtagEventDirective,
    MatIcon,
    MatIconButton,
    MatTooltip,
  ],
  templateUrl: './cc-row-menu-header.component.html',
  styleUrl: './cc-row-menu-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcRowMenuHeaderComponent implements IHeaderAngularComp {
  constructor(private ccListApi: CcListApiService) {}

  /**
   * The method is called on the header component once.
   * @param params
   */
  agInit(params: IHeaderParams): void {};

  /**
   * Gets called when a new Column Definition has been set for this header.
   * If you handle the refresh of your header return true otherwise return false
   * and the grid will re-create your header from scratch.
   * @param params
   */
  refresh(params: IHeaderParams): boolean {
    return true;
  };

  /**
   * Resets column state to the value provided initially by column definitions.
   * @param e
   */
  resetTableLayout() {
    this.ccListApi.gridApi.resetColumnState();
  }

  /**
   * Adjust width of visible columns to fit available horizontal space (without overflow)
   * @param e
   */
  sizeColumnsToFit() {
    this.ccListApi.gridApi.sizeColumnsToFit();
  }

}
